import "./Hero.css";
import React, { useState } from "react";

export default function Hero({ clubData }) {
  const [imageError, setImageError] = useState(false);
  const [logoError, setLogoError] = useState(false);
  
  // Generate a descriptive alt text for the hero image
  const heroImageAlt = clubData?.name ? `${clubData.name} golf club course view` : 'Golf course view';
  const logoAlt = clubData?.name ? `${clubData.name} logo` : 'Golf club logo';

  const handleImageError = () => {
    setImageError(true);
  };

  const handleLogoError = () => {
    setLogoError(true);
  };

  const heroStyle = {
    backgroundColor: '#326038', // Default green background
    backgroundImage: clubData?.gallery?.[0]
      ? imageError 
        ? 'url(placeholder_1.jpg)' // Show placeholder only on error
        : `url(${clubData.gallery[0]})` // Show gallery image if available
      : 'none', // No background image if no gallery image
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  return (
    <header className="Header" role="banner">
      <div
        className="Heroimg"
        style={heroStyle}
        role="img"
        aria-label={heroImageAlt}
        onError={handleImageError}
      />
      <div className="HeroContent">         
        {clubData && (
          <img 
            src={logoError ? "GLFR-fallback-logo.png" : (clubData.logo || "GLFR-fallback-logo.png")}
            alt={logoAlt}
            loading="eager"
            width="150"
            height="150"
            style={{
              objectFit: 'contain ',
              width: '150px',
              height: '150px'
            }}
            onError={handleLogoError}
          />
        )}
        <h1 style={{color: 'white'}}>{clubData?.name || 'Welcome to our Golf Club'}</h1>
      </div>
    </header>
  );
}
